var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_vm._l((Array(20).keys()),function(_){return _c('div',{key:_,staticClass:"decoration-block"})}),_vm._l((_vm.floating_chars),function(char){return _c('div',{key:char,staticClass:"floating-char"},[_vm._v(_vm._s(char))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }